import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import { toast } from "react-toastify";
import axiosInstance from "../../config/axiosInterceptor";

const AddVip = () => {
  const [type, setType] = useState("");
  const [svgaName, setSvgaName] = useState("");
  const [imageName, setImageName] = useState("");
  const [firstColor, setFirstColor] = useState("#000000");
  const [secondColor, setSecondColor] = useState("#000000");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const subbbb = async (e) => {
    e.preventDefault();
    if (submitting) return;
    var t = $("select[name='type']").val();
    var a = $("input[name='levelreq']").val();
    var b = $("input[name='title']").val();
    var c = $("input[name='price']").val();
    var d = $("input[name='valid']").val();
    var e = $("input[name='svga']")[0].files[0]; // Access the file object
    var f = $("input[name='image']")[0].files[0]; // Access the file object
    let text = "This field cannot be empty";

    if (t == "") {
      $(".form-error0").html(text);
    }
    if (t == "LEVEL" && a == "") {
      $(".form-error1").html(text);
    }
    if (b == "") {
      $(".form-error2").html(text);
    }
    if (t != "LEVEL" && c == "") {
      $(".form-error3").html(text);
    }
    if (d == "") {
      $(".form-error4").html(text);
    }
    if (
      t != "" &&
      (t != "LEVEL" || a != "") &&
      b != "" &&
      (t == "LEVEL" || c != "") &&
      d != ""
    ) {
      // let formData = new FormData(e.target); // Use e.target to access the form element
      let formData = new FormData();
      formData.append("type", t);
      formData.append("levelreq", t === "LEVEL" ? a : "");
      formData.append("title", b);
      formData.append("price", t === "LEVEL" ? "0" : c);
      formData.append("valid", d);
      formData.append("firstColor", firstColor);
      formData.append("secondColor", secondColor);
      if (e) formData.append("svga", e);
      if (f) formData.append("image", f);

          setSubmitting(true);
          await axiosInstance.post(`${process.env.REACT_APP_BASEURL5}/admin/vip/addVip`,formData).then((res)=>{
            if (res.data.success === 1) {
              toast.success(res.data.message);
              // Stays disabled through the redirect - re-enabling here would
              // reopen the double-submit window.
              setTimeout(() => {
                navigate("/admin/manageVip");
              }, 1000);
            } else {
              toast.error(res.data.message);
              setSubmitting(false);
            }
          }).catch((e)=>{
            toast.error(e.message)
            setSubmitting(false);
          });

      // $.ajax({
      //   url: `${process.env.REACT_APP_BASEURL}/admin/vip/addVip`,
      //   type: "post",
      //   dataType: "json",
      //   data: formData,
      //   contentType: false,
      //   processData: false,
      //   success: function (res) {
      //     if (res.success === 1) {
      //       toast.success(res.message);
      //       setTimeout(() => {
      //         navigate("/admin/manageVip");
      //       }, 1000);
      //     } else {
      //       toast.error(res.message);
      //     }
      //   },
      // });
    }
  };

  return (
    <>
      <section className="content-header">
        <h1>Add Vip</h1>
        <ol className="breadcrumb">
          <li>
            <Link to="/admin">
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li>
            <Link to="/admin/manageVip">Manage Vip</Link>
          </li>
          <li className="active">Add Vip</li>
        </ol>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-md-10">
            <form
              role="form"
              id="form"
              method="post"
              onSubmit={subbbb}
              encType="multipart/form-data"
            >
              <div className="box box-warning">
                <div className="box-header with-border">
                  <h3 className="box-title">Add</h3>
                </div>
                <div className="box-body">
                  <div className="form-group">
                    <label>Type*</label>
                    <select
                      className="form-control"
                      name="type"
                      value={type}
                      onChange={(e) => {
                        setType(e.target.value);
                        $(".form-error0").html("");
                      }}
                    >
                      <option value="">Select Type</option>
                      <option value="PLAN">PLAN</option>
                      <option value="PURCHASED">PURCHASED</option>
                      <option value="LEVEL">LEVEL</option>
                    </select>
                    <div className="form-error0 text-danger"></div>
                  </div>
                  {type === "LEVEL" && (
                    <div className="form-group">
                      <label>Level Required*</label>
                      <input
                        type="number"
                        className="form-control"
                        name="levelreq"
                        placeholder="level required"
                        onChange={() => {
                          $(".form-error1").html("");
                        }}
                      />
                      <div className="form-error1 text-danger"></div>
                    </div>
                  )}
                  <div className="form-group">
                    <label>Title*</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      placeholder="Title"
                      onChange={() => {
                        $(".form-error2").html("");
                      }}
                    />
                    <div className="form-error2 text-danger"></div>
                  </div>
                  {type !== "LEVEL" && (
                    <div className="form-group">
                      <label>Price*</label>
                      <input
                        type="number"
                        className="form-control"
                        name="price"
                        placeholder="Price"
                        onChange={() => {
                          $(".form-error3").html("");
                        }}
                      />
                      <div className="form-error3 text-danger"></div>
                    </div>
                  )}
                  <div className="form-group">
                    <label>Valid For*</label>
                    <input
                      type="number"
                      className="form-control"
                      name="valid"
                      placeholder="For Days"
                      onChange={() => {
                        $(".form-error4").html("");
                      }}
                    />
                    <div className="form-error4 text-danger"></div>
                  </div>
                  <div className="form-group">
                    <label>First Color</label>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <input
                        type="color"
                        name="firstColor"
                        value={firstColor}
                        onChange={(e) => setFirstColor(e.target.value)}
                        style={{ width: "60px", height: "38px", padding: "2px", cursor: "pointer" }}
                      />
                      <input
                        type="text"
                        className="form-control"
                        value={firstColor}
                        onChange={(e) => setFirstColor(e.target.value)}
                        placeholder="#000000"
                        style={{ maxWidth: "160px" }}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Second Color</label>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <input
                        type="color"
                        name="secondColor"
                        value={secondColor}
                        onChange={(e) => setSecondColor(e.target.value)}
                        style={{ width: "60px", height: "38px", padding: "2px", cursor: "pointer" }}
                      />
                      <input
                        type="text"
                        className="form-control"
                        value={secondColor}
                        onChange={(e) => setSecondColor(e.target.value)}
                        placeholder="#000000"
                        style={{ maxWidth: "160px" }}
                      />
                      <div
                        title="Gradient preview"
                        style={{
                          flex: 1,
                          height: "38px",
                          borderRadius: "4px",
                          border: "1px solid #ddd",
                          background: `linear-gradient(90deg, ${firstColor}, ${secondColor})`,
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Svga</label>
                    <input
                      type="file"
                      className="form-control"
                      name="svga"
                      onChange={(e) => {
                        setSvgaName(e.target.files[0] ? e.target.files[0].name : "");
                      }}
                    />
                    {svgaName && <div className="text-success"><i className="fa fa-check"></i> {svgaName} attached</div>}
                  </div>
                  <div className="form-group">
                    <label>Image</label>
                    <input
                      type="file"
                      className="form-control"
                      name="image"
                      onChange={(e) => {
                        setImageName(e.target.files[0] ? e.target.files[0].name : "");
                      }}
                    />
                    {imageName && <div className="text-success"><i className="fa fa-check"></i> {imageName} attached</div>}
                  </div>
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-default"
                      onClick={() => {
                        $("#form")[0].reset();
                        setType("");
                        setSvgaName("");
                        setImageName("");
                        setFirstColor("#000000");
                        setSecondColor("#000000");
                        $(".form-error0, .form-error1, .form-error2, .form-error3, .form-error4").html("");
                      }}
                    >
                      Reset
                    </button>{" "}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => navigate("/admin/manageVip")}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-success pull-right"
                      name="submit"
                      disabled={submitting}
                    >
                      {submitting ? (
                        <>
                          <i className="fa fa-spinner fa-spin mr-1" /> Saving...
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddVip;
